
import { UserWithRole, UserRole } from '@/pages/admin/types';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export const useUserActions = () => {
  const handleUserEdit = (
    user: UserWithRole,
    setSelectedUser: (user: UserWithRole) => void,
    setSelectedRole: (role: UserRole) => void,
    setIsEditDialogOpen: (open: boolean) => void
  ) => {
    setSelectedUser(user);
    setSelectedRole(user.role || "user");
    setIsEditDialogOpen(true);
  };

  const handleUserPasswordReset = (
    user: UserWithRole,
    setSelectedUserForPasswordReset: (user: UserWithRole) => void,
    setIsPasswordResetDialogOpen: (open: boolean) => void
  ) => {
    setSelectedUserForPasswordReset(user);
    setIsPasswordResetDialogOpen(true);
  };

  const handleResendCredentials = async (user: UserWithRole) => {
    try {
      const { data, error } = await supabase.functions.invoke('resend-user-credentials', {
        body: { email: user.email }
      });

      if (error) throw error;

      toast.success('Credentials reset and email sent successfully');
      return true;
    } catch (error) {
      console.error('Error resending credentials:', error);
      toast.error('Failed to resend credentials');
      return false;
    }
  };

  return {
    handleUserEdit,
    handleUserPasswordReset,
    handleResendCredentials
  };
};
